import { collection, deleteDoc, doc, onSnapshot, query, where } from 'firebase/firestore';
import React, { useEffect, useState } from 'react'
import { db } from '../firebase';

const AssignedStudent = () => {
    const [userAssignedStudent, setUserAssignedStudent] = useState([]);
  
    useEffect(() => {
      const q = query(
        collection(db, "studentUserTypeVerify"),
        where("status", "==", "assigned")
      );
      onSnapshot(q, (querySnapshot) => {
        let userArray = [];
        querySnapshot.forEach((doc) => {
          userArray.push({ id: doc.id, ...doc.data() });
        });
        setUserAssignedStudent(userArray);
      });
    }, []);


    const deleteField = async (pid) => {
        await deleteDoc(doc(db, "studentUserTypeVerify", pid));
        console.log("Deleted ===>" + pid);
      };
  return (
    <div className="p-10">
      <div>
        <table className="w-full  text-center">
          <thead className="border-b  ">
            <tr className="bg-gray-100">
              <th className="py-3 "> Sl No.</th>
              <th className="py-3 ">Student Code</th>
              <th className="py-3 ">Email</th>
              <th className="py-3 ">Select</th>
              <th className="py-3 ">Assign</th>
              <th className="py-3 ">Delete</th>
            </tr>
          </thead>
          <tbody>
            {userAssignedStudent?.map((item, index) => (
              <tr className="border-b" key={index}>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {++index}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.studentIdNumber}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.email}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                {item.userType}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  {item.status}
                </td>
                <td className="py-3 px-10 text-sm font-medium text-gray-900 border-r">
                  <button
                    className="text-white bg-red-600 py-1 px-1 rounded-md "
                    onClick={() => deleteField(item.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div></div>
    </div>
  )
}

export default AssignedStudent